<template>
  <v-card>
    <v-toolbar dense flat style="background-color: transparent">
      <v-btn
        icon
        absolute
        style="top: 0px"
        :to="'/weserve_admin_login/-/promotion-manage'"
      >
        <v-icon>arrow_back</v-icon>
      </v-btn>
      <v-spacer />
      <v-toolbar-title>
        <h1 class="text-pagename">Promotion Log for all province</h1>
      </v-toolbar-title>
      <v-spacer />
    </v-toolbar>
    <LogListTable />
  </v-card>
</template>

<script>
import LogListTable from "@/components/back-office/PromotionAllProvince/PromotionLogListTable.vue";
export default {
  components: {
    LogListTable,
  },
  mounted() {
    const path = [
      {
        text: "Select province",
        disabled: false,
        href: "/weserve_admin_login/select/",
      },
      {
        text: "Select service",
        disabled: false,
        href: "/weserve_admin_login/control/" + this.$route.params.province,
      },
      {
        text: "Promotion management",
        disabled: false,
        href: "/weserve_admin_login/-/promotion-manage",
      },
      {
        text: "Promotion Log",
        disabled: true,
      },
    ];
    this.$store.commit("backOffice/saveRecentRoute", path);
  },
};
</script>

<style></style>
